module.exports = __webpack_public_path__ + "static/farm-field-0ee2408a006715c294d98718c9c04e6d.jpg";